/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppNotesRouteImport } from './routes/_app/notes'
import { Route as AppMindPalaceRouteImport } from './routes/_app/mind-palace'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppCaptureRouteImport } from './routes/_app/capture'
import { Route as AppMindPalaceIndexRouteImport } from './routes/_app/mind-palace.index'
import { Route as AppMindPalaceDocumentIdRouteImport } from './routes/_app/mind-palace.$documentId'
import { Route as AppMindPalaceRoomRoomIdRouteImport } from './routes/_app/mind-palace.room.$roomId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppNotesRoute = AppNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppRoute,
} as any)
const AppMindPalaceRoute = AppMindPalaceRouteImport.update({
  id: '/mind-palace',
  path: '/mind-palace',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppCaptureRoute = AppCaptureRouteImport.update({
  id: '/capture',
  path: '/capture',
  getParentRoute: () => AppRoute,
} as any)
const AppMindPalaceIndexRoute = AppMindPalaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMindPalaceRoute,
} as any)
const AppMindPalaceDocumentIdRoute = AppMindPalaceDocumentIdRouteImport.update({
  id: '/$documentId',
  path: '/$documentId',
  getParentRoute: () => AppMindPalaceRoute,
} as any)
const AppMindPalaceRoomRoomIdRoute = AppMindPalaceRoomRoomIdRouteImport.update({
  id: '/room/$roomId',
  path: '/room/$roomId',
  getParentRoute: () => AppMindPalaceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/capture': typeof AppCaptureRoute
  '/chat': typeof AppChatRoute
  '/home': typeof AppHomeRoute
  '/integrations': typeof AppIntegrationsRoute
  '/mind-palace': typeof AppMindPalaceRouteWithChildren
  '/notes': typeof AppNotesRoute
  '/mind-palace/$documentId': typeof AppMindPalaceDocumentIdRoute
  '/mind-palace/': typeof AppMindPalaceIndexRoute
  '/mind-palace/room/$roomId': typeof AppMindPalaceRoomRoomIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/capture': typeof AppCaptureRoute
  '/chat': typeof AppChatRoute
  '/home': typeof AppHomeRoute
  '/integrations': typeof AppIntegrationsRoute
  '/notes': typeof AppNotesRoute
  '/mind-palace/$documentId': typeof AppMindPalaceDocumentIdRoute
  '/mind-palace': typeof AppMindPalaceIndexRoute
  '/mind-palace/room/$roomId': typeof AppMindPalaceRoomRoomIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/capture': typeof AppCaptureRoute
  '/_app/chat': typeof AppChatRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/mind-palace': typeof AppMindPalaceRouteWithChildren
  '/_app/notes': typeof AppNotesRoute
  '/_app/mind-palace/$documentId': typeof AppMindPalaceDocumentIdRoute
  '/_app/mind-palace/': typeof AppMindPalaceIndexRoute
  '/_app/mind-palace/room/$roomId': typeof AppMindPalaceRoomRoomIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/capture'
    | '/chat'
    | '/home'
    | '/integrations'
    | '/mind-palace'
    | '/notes'
    | '/mind-palace/$documentId'
    | '/mind-palace/'
    | '/mind-palace/room/$roomId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/capture'
    | '/chat'
    | '/home'
    | '/integrations'
    | '/notes'
    | '/mind-palace/$documentId'
    | '/mind-palace'
    | '/mind-palace/room/$roomId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/capture'
    | '/_app/chat'
    | '/_app/home'
    | '/_app/integrations'
    | '/_app/mind-palace'
    | '/_app/notes'
    | '/_app/mind-palace/$documentId'
    | '/_app/mind-palace/'
    | '/_app/mind-palace/room/$roomId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/notes': {
      id: '/_app/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AppNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mind-palace': {
      id: '/_app/mind-palace'
      path: '/mind-palace'
      fullPath: '/mind-palace'
      preLoaderRoute: typeof AppMindPalaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/capture': {
      id: '/_app/capture'
      path: '/capture'
      fullPath: '/capture'
      preLoaderRoute: typeof AppCaptureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mind-palace/': {
      id: '/_app/mind-palace/'
      path: '/'
      fullPath: '/mind-palace/'
      preLoaderRoute: typeof AppMindPalaceIndexRouteImport
      parentRoute: typeof AppMindPalaceRoute
    }
    '/_app/mind-palace/$documentId': {
      id: '/_app/mind-palace/$documentId'
      path: '/$documentId'
      fullPath: '/mind-palace/$documentId'
      preLoaderRoute: typeof AppMindPalaceDocumentIdRouteImport
      parentRoute: typeof AppMindPalaceRoute
    }
    '/_app/mind-palace/room/$roomId': {
      id: '/_app/mind-palace/room/$roomId'
      path: '/room/$roomId'
      fullPath: '/mind-palace/room/$roomId'
      preLoaderRoute: typeof AppMindPalaceRoomRoomIdRouteImport
      parentRoute: typeof AppMindPalaceRoute
    }
  }
}

interface AppMindPalaceRouteChildren {
  AppMindPalaceDocumentIdRoute: typeof AppMindPalaceDocumentIdRoute
  AppMindPalaceIndexRoute: typeof AppMindPalaceIndexRoute
  AppMindPalaceRoomRoomIdRoute: typeof AppMindPalaceRoomRoomIdRoute
}

const AppMindPalaceRouteChildren: AppMindPalaceRouteChildren = {
  AppMindPalaceDocumentIdRoute: AppMindPalaceDocumentIdRoute,
  AppMindPalaceIndexRoute: AppMindPalaceIndexRoute,
  AppMindPalaceRoomRoomIdRoute: AppMindPalaceRoomRoomIdRoute,
}

const AppMindPalaceRouteWithChildren = AppMindPalaceRoute._addFileChildren(
  AppMindPalaceRouteChildren,
)

interface AppRouteChildren {
  AppCaptureRoute: typeof AppCaptureRoute
  AppChatRoute: typeof AppChatRoute
  AppHomeRoute: typeof AppHomeRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppMindPalaceRoute: typeof AppMindPalaceRouteWithChildren
  AppNotesRoute: typeof AppNotesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCaptureRoute: AppCaptureRoute,
  AppChatRoute: AppChatRoute,
  AppHomeRoute: AppHomeRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppMindPalaceRoute: AppMindPalaceRouteWithChildren,
  AppNotesRoute: AppNotesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
